<template>
    <div id="news">
        <div id="container1"  v-if="newsList">

            <newsHeader></newsHeader>

            <div id="content">
                <div class="leftBox">
                    <img src="/images/web_img/recent_news.jpg" alt="">
                    <div v-for="news in newsLeftBox" :key="news.id">
                        <router-link :to="{ name: 'news', params: { id: news.id }}" target="_blank"><img :src="news.pic" alt="" loading="lazy"></router-link>
                        <p>{{news.title}}</p>
                    </div>
                </div>

                <div class="middleBox">
                    <div>
<!--                        你所在的位置: 新闻-->
                    </div>
                    <div v-for="newstitle in newsMidBox" :key="newstitle.title">
                        {{newstitle.title}}
                    </div>
                    <div v-for="newsmid in newsMidBox" :key="newsmid.id">
                        <p v-html="safeContent"></p>
                    </div>
                    
                </div>

                <div class="rightBox">
                    <img src="/images/web_img/related_news.jpg" alt="">

                    <p v-for="news in newsRightBox" :key="news.id">
                        <router-link :to="{ name: 'news', params: { id: news.id }}" target="_blank">{{news.title}}</router-link>
                     </p>

                  <img src='/images/web_img/image888.jpg' alt="">
                </div>
            </div>

            <pageFooter></pageFooter>

        </div>
    </div>
</template>
<script>
import pageFooter from "@/components/Footer";
import newsHeader from "@/components/Header";
import { request } from "@/api/http";
import { sanitizeHtml } from "@/utils/sanitize";

export default {
    components:{
        pageFooter,
        newsHeader,
    },

    data(){
        return{
            newsid : this.$route.params.id,
            newsList : [],

            newsLeftBox: [],

            newsMidRightBox: [],
            newsRightBox:[],
            newsMidBox: [],
        }
    },
    computed: {
        // 正文经 XSS 清洗后再交给 v-html 渲染
        safeContent(){
            const mid = this.newsMidBox[0];
            return mid ? sanitizeHtml(mid.content) : '';
        }
    },
    mounted(){
        this.getLeftBoxData();
        this.getMidRightBoxdata();
    },
    methods: {

        getLeftBoxData(){
            request('/CalawaEnServlet/NewsServlet', { type: 'getAllNewsForUnLocked' })
            .then(res=> {
                this.newsList = res.data;
                if(this.newsList.length>0 && this.newsList.length<11){
                    for(let i = 0;i < this.newsList.length; i++){
                        this.newsLeftBox.push(this.newsList[i]);
                    }
                }
            })
            .catch(error=> {
                console.log(error);
            });
        },
        getMidRightBoxdata(){
            request('/CalawaEnServlet/NewsServlet', { type: 'getNewsById', id: this.newsid })
            .then(res=> {
                this.newsMidRightBox = res.data;
                if(this.newsMidRightBox.length>0){
                    this.newsMidBox.push(this.newsMidRightBox[0]);
                    if(this.newsMidRightBox.length>1 && this.newsMidRightBox.length<30){
                        for (let i = 1; i < this.newsMidRightBox.length; i++) {
                            this.newsRightBox.push(this.newsMidRightBox[i]);
                        }
                    }
                }
            })
            .catch(error=> {
                console.log(error);
            });
        },
    },
}
</script>

<style scoped>
/* v-html元素的控制 */
.middleBox>div:nth-child(3)>p>>> p{
    /* 段首空两格 */
    text-indent: 2em;
}
.middleBox>div:nth-child(3)>p>>> p>img{
    width: 500px !important;
    object-fit: contain;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

#news{
    width: 100%;
    // min-height: 1700px;

    #container1{
        width:1020px;
        // min-height: 1700px;
        background-color: #ccc;

        margin: 0 auto 0 auto;



        #content{
            margin: 0 10px 0 10px;
            min-height: 1530px;

            background-color: white;


            .leftBox{
                width: 115px;
                height: 1420px;

                float: left;
                padding: 20px 0 0 0;

                background-color: white;

                img{
                    width: 95px;
                    height:65px;
                }

                div{
                    margin-top: 20px;
                    p{
                        width: 95px;
                        font-size: 14px;

                        text-overflow:ellipsis;
                        overflow: hidden;
                        white-space:nowrap; 

                        margin: 5px auto 0 auto;
                    }
                }
            }
            .middleBox{
                width: 690px;
                

                float: left;
                background-color: white;

                img{
                    text-align: center;
                    margin: 20px auto 0 115px;
                }

                >div:nth-child(1){
                    width: 690px;
                    height: 40px;

                    padding: 13px;

                    text-align: left;
                    font-size: 13px;
                }
                >div:nth-child(2){
                    width: 690px;
                    height: 60px;

                    padding: 15px 0 5px 0; 

                    font-size: 20px;

                    border-bottom: 1px dashed black;
                    margin-bottom: 40px;
                }
                >div:nth-child(3){
                    width: 630px;
                    height: 1153px;

                    padding: 0 30px 0 30px;
                    text-align: left;
                    
                    >p{
                        >>> p{
                            color:red;

                            img{
                                text-align: center;
                                margin: 0 auto 0 auto;

                                width:500px !important;
                            }
                        }
                    }

                    // img{
                    //     width:500px !important;


                    // }
                    
                }
            }
            .rightBox{
                width: 195px;
                height: 1440px;

                float: left;

                background-color: #ddd;
                img:nth-child(1){
                    width:195px;
                    height:65px;

                    margin-top: 20px;
                }

                p{
                    width:175px;

                    padding: 10px 10px 10px 15px;

                    font-size: 13px;
                    text-align: left;
                    
                    overflow:hidden;
                    white-space:nowrap; 
                    text-overflow: ellipsis;

                    border-bottom: 1px dashed #bbb;
                    a{
                        color: black;
                        &:hover{
                            text-decoration:none;
                            cursor: pointer;
                        }
                    }
                }
                img:nth-child(3){
                    width:175px;
                    height: 183px;

                    margin-top: 20px;
                }
            }
        }

    }

}
</style>

